var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
define(["require", "exports", "backbone", "client/client-extensions/extension-manager", "@lit/context", "./app-context", "utils/jsonpath", "./custom-element-registry", "./chat", "./result"], function (require, exports, Backbone, extension_manager_1, context_1, app_context_1, jsonpath_1, custom_element_registry_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.WebComponentsExtensionLoader = exports.WebComponentsExtension = void 0;
    Backbone = __importStar(Backbone);
    extension_manager_1 = __importDefault(extension_manager_1);
    jsonpath_1 = __importDefault(jsonpath_1);
    function asArray(rootEls) {
        if (rootEls instanceof Array) {
            return rootEls;
        }
        return [rootEls];
    }
    class WebComponentView {
        constructor(options) {
            this.events = Object.assign({}, Backbone.Events);
            this.subViews = [];
            // TODO are we creating a new element?
            // assert that options.el is set.
            this.options = options;
            this.setModel(this.options.model);
            if (this.options.el instanceof HTMLElement) {
                this.el = this.options.el;
                if (this.options.el.onViewCreate) {
                    this.options.el.onViewCreate(this, options);
                }
            }
        }
        setModel(model) {
            if (this.model) {
                this.events.stopListening(this.model);
            }
            this.model = model;
            if (this.model) {
                // this.listenTo(this.model, 'computing', this.computing);
                // this.listenTo(this.model, 'computed', this.computed);
                // this.listenTo(this.model, 'allcomputationfinished', this.allcomputationfinished);
                // this.listenTo(this.model, 'aborted', this.aborted);
                // this.listenTo(this.model, 'change', this.change);
                this.events.listenTo.call(this, this.model, 'remove', this.remove);
                this.events.listenTo.call(this, this.model, 'destroy', this.remove);
            }
        }
        listenTo(...args) {
            this.events.listenTo.apply(this, args);
        }
        on(...args) {
            this.events.on.call(this, args);
        }
        render() {
            return this;
        }
        remove() {
            this.events.stopListening();
            // forward
            if (this.options.el instanceof HTMLElement) {
                if (this.options.el.onViewRemove) {
                    this.options.el.onViewRemove();
                }
            }
            if (this.options.ownEl) {
                this.el.parentNode.removeChild(this.el);
            }
        }
    }
    class WebComponentTemplate {
        constructor(el, node, application, settingsConfig) {
            this.el = el;
            this.node = node;
            this.application = application;
            this.settingsConfig = settingsConfig;
            this.childrenPromise = Promise.resolve(this.node && this.node.children || []);
            this.instances = [];
        }
        model(model) {
            const modelName = this.el.getAttribute("model");
            const path = this.el.getAttribute("path");
            if (modelName) {
                model = this.application.models[modelName];
            }
            if (path && model.submodel) {
                const localPath = jsonpath_1.default.parsePath(path);
                model = model.submodel(localPath);
            }
            return model;
        }
        createView(options) {
            let el = options.node.el || this.el;
            let node = options.node;
            let children = this.node.children || [];
            if (options.forceCreateNewElement) {
                // at least one element this would work.
                children = children.map((node) => Object.assign({}, node));
                const getNodeByEl = (el) => {
                    return children.find((node) => node.el == el);
                };
                function cloneRec(el) {
                    const node = getNodeByEl(el);
                    const clonedEl = el.cloneNode();
                    if (node != null) {
                        node.el = clonedEl;
                    }
                    for (const childNode of Array.from(el.childNodes)) {
                        if (childNode instanceof HTMLElement) {
                            clonedEl.appendChild(cloneRec(childNode));
                        }
                        else {
                            clonedEl.appendChild(childNode.cloneNode(true));
                        }
                    }
                    return clonedEl;
                }
                el = cloneRec(el);
                node = Object.assign({}, node);
                node.chidren = children;
            }
            let model = this.model(options.model);
            let viewOptions = Object.assign({}, options, { el, node, model, settingsConfig: this.settingsConfig });
            if (el != this.el) {
                viewOptions.ownEl = true;
            }
            let result = new WebComponentView(viewOptions);
            this.instances.push(result);
            let subViews = children.map((childNode) => childNode.template.createView({
                application: options.application,
                model: model,
                node: childNode,
                el: childNode.el
            }));
            result.subViews = subViews;
            return result;
        }
        getOwnDisplayedProperties() {
            if (this.el.getDisplayedProperties) {
                /// TODO merge the properties.
                return this.el.getDisplayedProperties();
            }
            return {};
        }
        getDisplayedProperties() {
            var _a;
            const getDispProps = (template) => {
                if (template.getDisplayedProperties) {
                    return template.getDisplayedProperties();
                }
                return {};
            };
            const childTemplates = (((_a = this.node) === null || _a === void 0 ? void 0 : _a.children) || []).map((node) => node.template);
            const childProps = childTemplates.reduce((props, template) => {
                return Object.assign(props, getDispProps(template));
            }, {});
            return Object.assign(childProps, this.getOwnDisplayedProperties());
        }
        remove(options) {
            var _a, _b;
            for (const instance of this.instances) {
                try {
                    instance.remove();
                }
                catch (e) {
                    console === null || console === void 0 ? void 0 : console.warn("Failed to call remove on isntance", e);
                }
            }
            this.instances = [];
            var nodes = (_a = options === null || options === void 0 ? void 0 : options.node) === null || _a === void 0 ? void 0 : _a.children;
            if (!nodes) {
                return;
            }
            for (const childNode of nodes) {
                (_b = childNode.template) === null || _b === void 0 ? void 0 : _b.remove({
                    node: childNode
                });
            }
        }
    }
    ;
    Mindbreeze.define("component!webcomponent", [], function () {
        return WebComponentTemplate;
    });
    class WebComponentsExtension {
        constructor(application, config) {
            this.contextProvidersByApp = {};
            this.application = application;
            // console.log("Creating WebComponentsExtension");
        }
        onApplicationInit(application) {
            // console.log("application init", application);
            var contextProviders = [];
            for (const rootEl of asArray(application.rootEls)) {
                // console.log("Application els", rootEl);
                const x = new context_1.ContextProvider(rootEl, app_context_1.applicationContext, application);
                x.hostConnected();
                contextProviders.push(x);
            }
            // ensures that context providers exists before constructing custom elements
            custom_element_registry_1.customElementRegistry.defineAll(window.customElements, application.getRootDomEl());
            this.contextProvidersByApp[application._id] = contextProviders;
            application.on("templatetree-create", this.onTemplateTreeCreate.bind(this));
        }
        onTemplateTreeCreate(templateTree, application) {
            templateTree.registerTemplateType((el) => {
                // console.log(`Checking ${el.tagName}`);
                const tagNameLower = el.tagName.toLowerCase();
                if (Object.keys(custom_element_registry_1.customElementRegistry.customElements).indexOf(tagNameLower) >= 0) {
                    // console.log(`Template for ${el.tagName} is webcomponent`);
                    return { templateType: "webcomponent" };
                }
                return;
            });
        }
        onApplicationDestroy(application) {
            delete this.contextProvidersByApp[application._id];
            // console.log("application destroy", application);
        }
        loadClientComponentAsync(name, parentLoader) {
            return __awaiter(this, void 0, void 0, function* () {
                if (name == "webcomponent") {
                    // console.log("Providing template type for component", name);
                    return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                        // const templateType = await parentLoader;
                        resolve(WebComponentTemplate);
                    }));
                }
                return yield parentLoader;
            });
        }
        unload() {
        }
    }
    exports.WebComponentsExtension = WebComponentsExtension;
    class WebComponentsExtensionLoader {
        constructor() {
            // console.log("constructing extension loader");
        }
        load(application, config) {
            return new WebComponentsExtension(application, config);
        }
    }
    exports.WebComponentsExtensionLoader = WebComponentsExtensionLoader;
    extension_manager_1.default.registerExtensionLoader("mindbreeze.client-web-components", new WebComponentsExtensionLoader());
});
